import Constants from 'expo-constants';

// Single source of truth for @react-google-maps/api's useJsApiLoader. Every
// call site must share THIS object: the underlying js-api-loader is a
// process-wide singleton that throws if called again with different options.
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  googleMapsApiKey: Constants.expoConfig!.extra!.googleMaps.apiKey,
  id: 'google-map-script',
};
